module.exports = __webpack_public_path__ + "img/man-avatar.cf48258c.png";